// extracted by css-extract-rspack-plugin
export default {"pageLayout":"src-app-pages-electronic-preparation-Integrate-Integrate-module__pageLayout-kKc6V5","headerTable":"src-app-pages-electronic-preparation-Integrate-Integrate-module__headerTable-UELWjf","reportTable":"src-app-pages-electronic-preparation-Integrate-Integrate-module__reportTable-dZpi3H","circle":"src-app-pages-electronic-preparation-Integrate-Integrate-module__circle-qJfpg4","bodyTable":"src-app-pages-electronic-preparation-Integrate-Integrate-module__bodyTable-sFajyY"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"pageLayout\":\"src-app-pages-electronic-preparation-Integrate-Integrate-module__pageLayout-kKc6V5\",\"headerTable\":\"src-app-pages-electronic-preparation-Integrate-Integrate-module__headerTable-UELWjf\",\"reportTable\":\"src-app-pages-electronic-preparation-Integrate-Integrate-module__reportTable-dZpi3H\",\"circle\":\"src-app-pages-electronic-preparation-Integrate-Integrate-module__circle-qJfpg4\",\"bodyTable\":\"src-app-pages-electronic-preparation-Integrate-Integrate-module__bodyTable-sFajyY\"}";
        // 1789362522830
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  